import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getCurrentInstance } from '@vue/composition-api';

/** 判断是否不是 undefined */

function isNotUndefined(val) {
  return typeof val !== 'undefined';
}
/**
 * 给组件挂载install方法
 */

function withInstall(component) {
  component.install = function install(vue) {
    if (component.name) {
      vue.component(component.name, component);
    }
  };

  return component;
}
function extend(target, source) {
  Object.keys(source).forEach(function (key) {
    target[key] = source[key];
  });
  return target;
}
/**
 * 暴露方法给组件外部通过$refs引用
 */

function useExpose(apis) {
  var instance = getCurrentInstance();

  if (instance) {
    Object.assign(instance.proxy, apis);
  }
}
/**
 * @param  {unknown} val
 * @returns boolean
 */

var isObject = function isObject(val) {
  return val !== null && _typeof(val) === 'object';
};

var rafFallback = function rafFallback(handler) {
  return window.setTimeout(handler, 16);
};

var _requestAnimationFrame = window.requestAnimationFrame || rafFallback;

var _cancelAnimationFrame = window.cancelAnimationFrame || window.clearTimeout;
/**
 * @description requestAnimationFrame
 * @param  {()=>void} handler
 * @param  {number} timeout?
 */


var raf = function raf(handler) {
  return _requestAnimationFrame.call(window, handler);
};
/**
 * @description 两次requestAnimationFrame间隔
 * @param  {()=>void} handler
 * @param  {number} timeout?
 */

var doubleRaf = function doubleRaf(handler) {
  return raf(function () {
    return raf(handler);
  });
};
/**
 * @description cancelAnimationFrame
 * @param  {number} handle
 */

var cancelRaf = function cancelRaf(handle) {
  _cancelAnimationFrame.call(window, handle);
};
/**
 * @description 为属性固定的静态对象赋值,例如reactive，替代通过.多次访问 减少代码量
 * @param  {T} target
 * @param  {T} source
 */

function staticObjectAssign(target, source) {
  Object.keys(source).forEach(function (key) {
    if (source[key] !== undefined && Object.prototype.hasOwnProperty.call(target, key)) {
      target[key] = source[key];
    }
  });
}

export { cancelRaf, doubleRaf, extend, isNotUndefined, isObject, raf, staticObjectAssign, useExpose, withInstall };
//# sourceMappingURL=index.js.map
